import React from "react";
import Component from "./Component";
import {RadioProvider} from "./RadioContext";
import PropTypes from "prop-types"


class RadioGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.getValue()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.valueDidUpdate(prevProps)) {
            this.setState({
                value: this.getValue()
            });
        }
    }

    getValueProps() {
        return "value";
    }

    _onChange(event) {
        this.setState({
            value: this.getEventValue(event)
        });
        super.onChange(event);
    }

    getEventValue(event) {
        return event.target.id;
    }

    render() {
        return (
            <React.Fragment>
                <RadioProvider value={{ value: this.state.value, onChange: this._onChange.bind(this)}}>
                    {this.props.children}
                </RadioProvider>
            </React.Fragment>
            );
    }
}

RadioGroup.propTypes = {
    id: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    formField: PropTypes.object,
};

export default RadioGroup